import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

type InputLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  label: React.ReactNode;
  isOptional?: boolean;
};

const InputLabel = ({ label, className, isOptional, ...props }: InputLabelProps) => {
  const { t } = useTranslation();
  return (
    <label className={clsx("flex text-sm", className)} {...props}>
      <span className={"font-medium text-secondary"}>
        {label}
        {isOptional && <span className="ml-1 text-quaternary">{t("optional")}</span>}
      </span>
    </label>
  );
};

export default InputLabel;
